// Importar traduções do pacote shared
import { resources } from '@fsd/shared';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': {
        translation: resources['pt-BR'],
      },
      'en-US': {
        translation: resources['en-US'],
      },
      'es-ES': {
        translation: resources['es-ES'],
      },
    },
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
